__turbopack_context__.v({
  "cta-button": "consent-gate-module-scss-module__Oun0kq__cta-button",
  "cta-label": "consent-gate-module-scss-module__Oun0kq__cta-label",
  "disclaimer": "consent-gate-module-scss-module__Oun0kq__disclaimer",
  "message-icon": "consent-gate-module-scss-module__Oun0kq__message-icon",
  "message-row": "consent-gate-module-scss-module__Oun0kq__message-row",
  "overlay": "consent-gate-module-scss-module__Oun0kq__overlay",
  "panel": "consent-gate-module-scss-module__Oun0kq__panel",
  "play-circle": "consent-gate-module-scss-module__Oun0kq__play-circle",
  "remember-checkbox": "consent-gate-module-scss-module__Oun0kq__remember-checkbox",
  "remember-helper": "consent-gate-module-scss-module__Oun0kq__remember-helper",
  "remember-section": "consent-gate-module-scss-module__Oun0kq__remember-section",
  "terms-link": "consent-gate-module-scss-module__Oun0kq__terms-link",
});
